import * as VisuallyHidden from "@radix-ui/react-visually-hidden"

import { Button } from "@/components/button"
import { Card } from "@/components/card"
import { DialogTitle } from "@/components/dialog"
import CloseDialogX from "@/components/icons/close-dialog-x"
import { ScrollArea } from "@/components/scroll-area"
import { Separator } from "@/components/separator"
import { Sheet, SheetClose, SheetContent } from "@/components/sheet"

import { SuperVoteLogo } from "../super-vote-logo"
import { superVoterFeatures } from "./super-voter-features"

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {}

const SuperVoterInfoDialog = ({ isOpen, setIsOpen }: { isOpen: boolean; setIsOpen: (isOpen: boolean) => void }) => {
  return (
    <Sheet modal={true} open={isOpen} onOpenChange={setIsOpen}>
      <SheetContent side="nft_dialog" className="flex h-full flex-col p-0">
        <div className="flex flex-col gap-1 px-2 py-4 sm:p-4">
          <div className="flex items-center justify-between">
            <div className="text-xl font-medium text-t100">
              <SuperVoteLogo />
            </div>
            <VisuallyHidden.Root>
              <DialogTitle>Super voter provides enhanced voting features on Scale</DialogTitle>
            </VisuallyHidden.Root>
            <SheetClose>
              <CloseDialogX onClick={noop} />
            </SheetClose>
          </div>
          <div className="mb-4 text-sm text-t200">Enhanced voting features on Scale.</div>
          <Separator
            className="relative h-0 w-full overflow-visible rounded-md border border-solid border-p400-light
          after:pointer-events-none after:absolute after:inset-[-1px] after:z-[1] after:rounded-md 
          after:shadow-[inset_0.5px_0.5px_0.5px_0px_hsla(220,39%,19%,1)] after:content-['']"
            decorative
          />
        </div>
        <div className="flex flex-grow flex-col gap-4 overflow-hidden px-4">
          <p className="text-t200">Features:</p>
          <ScrollArea>
            <Card.Container className="border-p400-light bg-p400">
              {superVoterFeatures.map((feature) => (
                <div key={feature.title}>
                  <p className="font-medium text-t100">{feature.title}</p>
                  <p className="text-t200">{feature.description}</p>
                </div>
              ))}
            </Card.Container>
          </ScrollArea>
        </div>
        <Separator
          className="relative h-0 w-full overflow-visible rounded-md border border-solid
          border-p400-light after:pointer-events-none after:absolute after:inset-[-1px] after:z-[1] 
          after:rounded-md after:shadow-[inset_0.5px_0.5px_0.5px_0px_hsla(220,43%,5%,1)] after:content-['']"
          decorative
        />
        <div className="flex justify-end px-4 pb-4">
          <Button
            variant="primary"
            onClick={async () => {
              setIsOpen(false)
            }}
          >
            Close
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  )
}

export default SuperVoterInfoDialog
